import React from "react";
import { Typography, ListItem, ListItemAvatar, Avatar, ListItemText, Box } from "@mui/material";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { ImagePath, ImageRelativePath } from "../../constants";


const TransactionCom = ({ item }) => {
    const { title, total_amount, start_date, cover_image, end_date, student_count ,payout_type,fixed_amount,percentage} = item
    return (
        <ListItem sx={{ width: "100%", display: "flex", alignItems: "center", my: 1 }}>
            <ListItemAvatar>
                <Avatar src={`${ImagePath}${ImageRelativePath}${cover_image}`} sx={{ width: "60px", height: "60px", borderRadius: "6px" }} />
            </ListItemAvatar>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: { sm: "center", xs: "start" }, flex: 1, ml: { sm: 3, xs: 2 }, flexDirection: { sm: "row", xs: "column" } }}>
                <ListItemText
                    primary={
                        <Typography variant="h5" fontWeight={500}>
                            {title}
                        </Typography>
                    }
                    secondary={
                        <>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                                <Typography variant="h6" color="secondary.light" fontWeight={500}>
                                    {start_date}-{end_date}
                                </Typography>
                                <Typography variant="h6" color="secondary.light" fontWeight={500}>
                                    Student Count:{student_count}
                                </Typography>
                            </Box>
                            {/* <Typography variant="h6" color="secondary.light" fontWeight={500}>
                              Type : {payout_type} 
                            </Typography> */}
                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 3}}>
                                <Typography variant="h6" color="secondary.light" fontWeight={500}>
                                Type : {payout_type} 
                                </Typography>
                                <Typography variant="h6" color="secondary.light" fontWeight={500}>
                                  {payout_type=== "Fixed_Variable" ? `(${fixed_amount} + ${percentage}%)`:""}
                                  {payout_type=== "Fixed" ? `(${fixed_amount})`:""}
                                  {payout_type=== "Variable" ? `(${percentage}%)`:""}
                                </Typography>
                            </Box>
                        </>

                    }
                />


                <Typography variant="body2" color="#067800" fontWeight={"500"} sx={{ display: "flex", alignItems: "center" }} >
                    <CurrencyRupeeIcon fontSize="20px" />  {total_amount}
                </Typography>

            </Box>
        </ListItem>


    )
}

export default TransactionCom